"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const RateTypeEnum_1 = require("../models/rates/RateTypeEnum");
const GenericValidator_1 = __importDefault(require("./GenericValidator"));
const baseRate_schema_1 = __importDefault(require("./schemas/baseRate.schema"));
class PredefinedManualRateValidator extends GenericValidator_1.default {
    _predefinedManualRateDetailSchema = joi_1.default.object({
        required: joi_1.default.boolean().required(),
        chargePerUnit: joi_1.default.number().precision(4).required(),
    });
    _schema = joi_1.default.object({
        ...baseRate_schema_1.default,
        rateType: joi_1.default.string()
            .valid(RateTypeEnum_1.RateTypeEnum.PredefinedManualRate)
            .required(),
        detail: this._predefinedManualRateDetailSchema.required(),
        glAccount: joi_1.default.string().allow('').optional(),
        customerId: joi_1.default.string().allow('').optional(),
        assignedCustomers: joi_1.default.number().integer().min(0).optional(),
        assignedRateSheets: joi_1.default.number().integer().min(0).optional(),
    }).required();
    validate(rate) {
        super.validate(rate, 'IPredefinedManualRate', this._schema);
    }
}
exports.default = PredefinedManualRateValidator;
